import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { ModuleService } from '../../services/module.service';
import { DropdownService } from '../../services/dropdown.service';
import { SubModuleService } from '../../services/sub-module.service';
import { ValidationService } from '../../services/validation.service';

@Component({
  selector: 'app-sub-module-list',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent],
  templateUrl: './sub-module-list.component.html',
  styleUrl: './sub-module-list.component.css'
})
export class SubModuleListComponent {
@ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Sub Module';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];

  module_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    { field: 'Module.name', headerName: 'Module', filter: true, flex: 1, },
    { field: 'name', headerName: 'Sub Module', filter: true, flex: 1, },
    { field: 'code', headerName: 'Sub Module Code', filter: true, flex: 1, },
    { headerName: "", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];

  bulk_columns = [
    { column_name: 'Module Name', type: 'text', return_as: 'module_id', sample_value: 'Master' },
    { column_name: 'Sub Module', type: 'text', return_as: 'name', sample_value: 'Country', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern,  },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'COUNTRY', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern  },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public sms: SubModuleService, public ar: ActivatedRoute, public ds:DropdownService, public vs:ValidationService) {
    this.form = this.fb.group({
      name: ['', [Validators.required,Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code)]],
       module_id:['',[Validators.required]],
      is_active:[true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['module']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }
  async get_list(filter?: any) {
    try {
       const res = await this.sms.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async delete(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async delet_module() {
    let res = await this.sms.delete(this.selected_ids.id);
    this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    this.selected_ids = {};
    this.confirmation_delete_modal?.close()
    this.ds.invalidate_dropdown_cache('sub_module');
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.sms.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('sub_module');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids.id) {
      let response = await this.sms.get(item.id);
      this.selected_ids = { ...response.data };
      this.form.patchValue({ ...this.selected_ids, });
    } else {
      this.selected_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.is_active = true
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.sms.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.sms.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('sub_module');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error:any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
       const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.sms, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }

}
